var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.repeaterBlocDto
    ? _c("div", { staticClass: "row m-0 px-0 px-md-2 px-lg-3 px-xl-4" }, [
        _c(
          "div",
          {
            staticClass:
              "col-12 col-md-5 p-0 p-md-2 pb-1 align-self-center text-center",
          },
          [
            _c("img", {
              staticClass: "img-fluid",
              attrs: {
                loading: "lazy",
                alt: "",
                src: _vm.repeaterBlocDto.picture,
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-12 col-md-7 p-0 p-md-2 align-self-center text-white",
          },
          [
            _c("h3", {
              staticClass: "h4 mb-0",
              domProps: { innerHTML: _vm._s(_vm.repeaterBlocDto.title) },
            }),
            _vm._v(" "),
            _c("p", [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.repeaterBlocDto.description),
                },
              }),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }